module.exports = __webpack_public_path__ + "img/approved-icon.a224314f.svg";